export default __webpack_public_path__ + "static/media/C0002.7bee13df.png";